import React from 'react';
import { Snackbar, Alert } from '@mui/material';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GreenCheckIcon from "../../assets/greencheckIcon.png";
// import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import ErrorCheckIcon from "../../assets/error.png";
import { useMediaQuery } from 'react-responsive';

const CommonToast = ({
  open,
  onClose,
  content,
  iconType = 'success', // New prop to control the icon type
  bgColor = '#4caf50',
  fontColor = '#ffffff',
  fontSize = '16px',
  fontWeight = 'bold',
  autoHideDuration = 3000,
  marginleft
}) => {
  const icon = iconType === 'success' ? (
    <img src={GreenCheckIcon} alt="Success" style={{ width: 24, height: 24 }} />
  ) : (
    <img src={ErrorCheckIcon} alt="Success" style={{ width: 24, height: 24 }} />
  );

  const isUnder992px = useMediaQuery({ maxWidth:992});

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{marginLeft: isUnder992px ? "" :  marginleft && marginleft }}
    >
      <Alert
        onClose={onClose}
        severity={iconType === 'success'  ? 'success' : 'error'}
        variant="filled"
        icon={icon} // Use dynamic icon based on iconType
        sx={{
          bgcolor: bgColor,
          color: fontColor,
          fontSize: fontSize,
          fontWeight: fontWeight,
          minWidth: '350px',
          width: 'auto',
          maxWidth: '100%',
        }}
      >
        {content}
      </Alert>
    </Snackbar>
  );
};

export default CommonToast;

